import { Component, OnInit, Input, Output, EventEmitter, SimpleChanges, OnChanges } from '@angular/core';
import * as moment from 'moment';
import { BaseComponent } from 'src/app/_base/base.component';
import { ClassesService, SectionsSubjectsService } from 'src/app/_services';
import { Subscription } from 'rxjs';
import { StageSelectionClass, AttendanceSearchModel, AttendanceSession, ViewSchedulePeriods, LmsSectionSubject } from 'src/app/_models';
import { Stage } from 'src/app/templates/models/stage.interface';
import { SchoolClass } from 'src/app/templates/models/schoolClass.interface';
import { Section } from 'src/app/templates/models/section.interface';
import { AttendanceMethodTypes } from 'src/app/_enums';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-register-filter',
  templateUrl: './register-filter.component.html',
  styleUrls: ['./register-filter.component.scss']
})
export class RegisterFilterComponent extends BaseComponent implements OnInit, OnChanges {
  @Input()
  class: SchoolClass = null;
  @Input()
  attendanceSearchModel: AttendanceSearchModel = {
    attendanceSessionId: null,
    classId: null,
    date: moment()
      .locale('en')
      .format('YYYY-MM-DD'),
    sectionId: null,
    schoolPeriodAllocationId: null,
    semesterId: this.mainFilterSvc.globalFilterObj.academicSemesterId
  };
  @Input()
  sections: Section[] = [];
  @Input()
  sessions: AttendanceSession[] = [];
  @Input()
  periods: ViewSchedulePeriods[] = [];
  @Input()
  schoolDays: number[] = [];
  @Output()
  attendanceSearchModelEmitter = new EventEmitter<AttendanceSearchModel>();
  @Output()
  periodEmitter = new EventEmitter<AttendanceSearchModel>();
  @Output()
  classEmitter = new EventEmitter<SchoolClass>();
  stageAndClasses: StageSelectionClass = new StageSelectionClass();
  stages: Stage[] = [];
  classes: SchoolClass[] = [];
  attendanceMethodTypes = AttendanceMethodTypes;
  subscription: Subscription;
  maxDate = moment()
    .locale('en')
    .format('YYYY-MM-DD');
  @Input()
  isFromLMS: boolean = false;
  localPeriods: ViewSchedulePeriods[] = [];
  sectionSubjectId: number = null;
  loaderActive: boolean = false;
  sectionDaysFilter = (d: Date): boolean => {
    const day = d.getDay();
    // Prevent Saturday and Sunday from being selected.
    return day !== -1;
    // tslint:disable-next-line:semicolon
  };
  constructor(
    private classesService: ClassesService,
    private route: ActivatedRoute,
    private sectionsSubjectsService: SectionsSubjectsService
  ) {
    super();
  }

  ngOnInit() {
    this.sectionSubjectId = parseInt(this.route.snapshot.params.sectionSubjectId, 10);
    if (this.sectionSubjectId) {
      this.sectionsSubjectsService.getByIdWithTeacherAllocationsAndSectionWithClass(this.sectionSubjectId).subscribe(
        (data: LmsSectionSubject) => {
          if (data) {
            this.attendanceSearchModel.classId = data.section.classId;
            this.attendanceSearchModel.sectionId = data.sectionId;
            this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
          }
        },
        () => {}
      );
      this.subscription = this.mainFilterObservable$.subscribe(() => {
        if (this.isFromLMS) {
          this.attendanceSearchModel.schoolPeriodAllocationId = null;
        }
        this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
      });
    } else {
      this.route.queryParams.subscribe(params => {
        if (!params) return;
        if (params.classId) {
          this.attendanceSearchModel.classId = Number(params.classId);
        }
      });
      this.getStagesWithClasses();
      this.subscription = this.mainFilterObservable$.subscribe(() => {
        this.getStagesWithClasses();
      });
    }
  }
  ngOnChanges(changes: SimpleChanges): void {
    if (changes.schoolDays !== undefined) {
      this.sectionDaysFilter = (d: Date): boolean => {
        const day = d.getDay();
        return this.schoolDays.find(item => item === day) === day;
      };
      const currentDayIndex = moment(this.attendanceSearchModel.date).day();
      if (this.schoolDays.findIndex(item => item === currentDayIndex) === -1 && changes.schoolDays.currentValue.length > 0) {
        for (let index = 0; index < 7; index++) {
          this.attendanceSearchModel.date = moment(this.attendanceSearchModel.date)
            .locale('en')
            .add(-1, 'd')
            .format('YYYY-MM-DD');
          if (this.schoolDays.findIndex(item => item === moment(this.attendanceSearchModel.date).day()) !== -1) {
            this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
            break;
          }
        }
      }
    }
    if (changes.periods !== undefined && this.isFromLMS) {
      this.localPeriods = this.periods.filter(item => item.sectionSubjectId === this.sectionSubjectId);
      if (this.localPeriods.length === 1 && this.attendanceSearchModel.schoolPeriodAllocationId !== this.localPeriods[0].periodId) {
        this.attendanceSearchModel.schoolPeriodAllocationId = this.localPeriods[0].periodId;
        setTimeout(() => {
          this.periodEmitter.emit(this.attendanceSearchModel);
        });
      }
    }
  }
  getStagesWithClasses(): void {
    this.loaderActive = true;
    this.classesService.getStagesAndClasses().subscribe(
      (data: StageSelectionClass) => {
        if (data) {
          this.stageAndClasses = data;
          this.stages = this.stageAndClasses.stages;
          const classes = this.stageAndClasses.classes;
          const isStageEnabled = true;
          if (isStageEnabled) {
            this.classes = classes;
            this.stages.map(s => (s.classes = classes.filter(c => c.stageId === s.stageId)));
            if (classes.filter(c => !c.stageId).length > 0) {
              const unknownStages: Stage = {
                stageName: 'غير معروف',
                stageNameEn: 'Unknown',
                stageId: -1,
                classes: classes.filter(c => !c.stageId)
              };
              this.stages.push(unknownStages);
            }
          } else {
            this.classes = this.stageAndClasses.classes;
          }
          if (this.attendanceSearchModel.classId) {
            this.class = this.classes.find(f => f.classId === this.attendanceSearchModel.classId);
            this.classEmitter.emit(this.class);
            this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
          } else this.class = null;
          //  this.classChanged();
        }
        this.loaderActive = false;
      },
      () => {
        this.loaderActive = false;
      }
    );
  }
  classChanged(): void {
    this.attendanceSearchModel.sectionId = null;
    this.attendanceSearchModel.attendanceSessionId = null;
    this.attendanceSearchModel.schoolPeriodAllocationId = null;
    this.attendanceSearchModel.date = moment()
      .locale('en')
      .format('YYYY-MM-DD');
    if (this.class) this.attendanceSearchModel.classId = this.class.classId;
    else this.attendanceSearchModel.classId = null;
    this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
    this.classEmitter.emit(this.class);
  }
  sectionIdChanged(): void {
    this.attendanceSearchModel.attendanceSessionId = null;
    this.attendanceSearchModel.schoolPeriodAllocationId = null;
    this.attendanceSearchModel.date = moment()
      .locale('en')
      .format('YYYY-MM-DD');
    this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
  }
  sessionIdChanged(): void {
    this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
  }
  periodIdChanged(): void {
    this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
  }
  dateChanged(): void {
    this.attendanceSearchModel.date = moment(this.attendanceSearchModel.date)
      .locale('en')
      .format('YYYY-MM-DD');
    if (this.isFromLMS) {
      this.attendanceSearchModel.schoolPeriodAllocationId = null;
    }
    this.attendanceSearchModelEmitter.emit(this.attendanceSearchModel);
  }
}
